import { VesselTypeInterface } from "@/types/apiTypes";
import { getToken } from "@/utils/authHelpers";
import axios from "axios";
import { API_BASE_URL } from "@/utils/api";

export const fetchVesselTypesApi = async (): Promise<VesselTypeInterface[]> => {
  const token = await getToken();
  if (!token) {
    throw new Error("Authorization token is required");
  }

  try {
    const response = await axios.get<VesselTypeInterface[]>(
      `${API_BASE_URL}/vessels`,
      {
        params: { distinct_types: true },
      },
    );
    return response.data || [];
  } catch (error) {
    console.error("Failed to fetch vessel types", error);
    return [];
  }
};
